// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uline[data-v-7d851f53]{border-bottom:1px solid #4a4a4a}.privacy[data-v-7d851f53],.uline[data-v-7d851f53]{margin-top:24px}.privacy_link[data-v-7d851f53]{cursor:pointer;color:#fff}", ""]);
// Exports
module.exports = exports;
